import React from "react";
import { IconProps as ChakraIconProps } from "@chakra-ui/react";
import { Icon } from "@chakra-ui/react";

const PixelSun = ({ ...rest }: ChakraIconProps) => {
  return (
    <Icon {...rest}>
      {/*<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
      <g clipPath="url(#clip0_353_2612)">
        <path d="M20.7999 19.2003H19.1999V20.8003H20.7999V19.2003Z" fill="white" />
        <path d="M22.3995 20.8001H20.7995V22.4001H22.3995V20.8001Z" fill="white" />
        <path d="M12.7993 6.39958H14.3993V4.79959H12.7993H11.1993H9.5993V6.39958H11.1993H12.7993Z" fill="white" />
        <path d="M11.2002 1.59994V3.19994H12.8002V1.59994V-6.10352e-05H11.2002V1.59994Z" fill="white" />
        <path d="M4.8005 3.19995H3.2005V4.79995H4.8005V3.19995Z" fill="white" />
        <path d="M3.19961 1.59962H1.59961V3.19962H3.19961V1.59962Z" fill="white" />
        <path d="M8.00009 8.00044H9.60009V6.40044H8.00009H6.40009V8.00044V9.60044H8.00009V8.00044Z" fill="white" />
        <path d="M3.2 12.7995V11.1995H1.6H0V12.7995H1.6H3.2Z" fill="white" />
        <path d="M6.40017 11.1999V9.59987H4.80017V11.1999V12.7999V14.3999H6.40017V12.7999V11.1999Z" fill="white" />
        <path d="M4.8005 19.2003H3.2005V20.8003H4.8005V19.2003Z" fill="white" />
        <path d="M3.19961 20.8001H1.59961V22.4001H3.19961V20.8001Z" fill="white" />
        <path d="M8.00009 15.9995V14.3995H6.40009V15.9995V17.5995H8.00009H9.60009V15.9995H8.00009Z" fill="white" />
        <path d="M11.1993 17.5995H9.5993V19.1995H11.1993H12.7993H14.3993V17.5995H12.7993H11.1993Z" fill="white" />
        <path d="M11.2002 22.4V24H12.8002V22.4V20.8001H11.2002V22.4Z" fill="white" />
        <path d="M16.0007 15.9995H14.4007V17.5995H16.0007H17.6007V15.9995V14.3995H16.0007V15.9995Z" fill="white" />
        <path d="M19.1999 12.7999V11.1999V9.59987H17.5999V11.1999V12.7999V14.3999H19.1999V12.7999Z" fill="white" />
        <path d="M20.7995 11.1995V12.7995H22.3995H23.9995V11.1995H22.3995H20.7995Z" fill="white" />
        <path d="M16.0007 8.00044V9.60044H17.6007V8.00044V6.40044H16.0007H14.4007V8.00044H16.0007Z" fill="white" />
        <path d="M20.7999 3.19995H19.1999V4.79995H20.7999V3.19995Z" fill="white" />
        <path d="M22.3995 1.59962H20.7995V3.19962H22.3995V1.59962Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_353_2612">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
      {/*</svg>*/}
    </Icon>
  );
};

export default PixelSun;
